import { env } from "@/constants/env";
import { APP_VERSION } from "@/constants/version";
import { initSentry } from "./init-sentry";
import { overrideConsoleToRemoteLog } from "./override-console";

export const initSentryLogging = () => {
  if (env.MODE === "production") {
    initSentry({
      dsn: env.VITE_DSN,
      // TODO: Setup the release number
      release: APP_VERSION,
      environment: env.VITE_ENVIRONMENT,
      debug: env.VITE_CLERK_ENV === "development",
      tracePropagation: ["localhost", env.VITE_API_URL],
    });

    overrideConsoleToRemoteLog();
  }
};
